import Box from "@mui/material/Box";
import Grid from "@mui/material/Unstable_Grid2";
import {Link} from "@mui/material";
import {useEffect, useState} from "react";
import "./header.css";

import logoSvg from "../../assets/img/icons/logoRedesigned.svg";
import {matchPath} from "react-router";
import {useHistory, useLocation} from "react-router-dom";
import {useSelector} from "react-redux";
import MapIcon from "../../icons/Map";
import DetailsIcon from "../../icons/Details";
import DashboardsIcon from "../../icons/Dashboards";
import CopyIcon from "../../icons/Copy";
import DocumentIcon from "../../icons/Document";
import UserIcon from "../../icons/User";
import DescriptionIcon from "@mui/icons-material/Description";

import StylizedMenuList from "../../StylizedComponents/StylizedMenuList";
import StylizedMenuItem from "../../StylizedComponents/StylizedMenuItem/index";
import {BURGER_MENU_LIST} from "../BurgerMenusToggler/constants";
import BurgerMenusToggler from "../BurgerMenusToggler";
import {cacheCleaner} from "../../shared/helpers/cacheCleaner";
import {storageKeys} from "../../shared/constants/storageKeys";

const mapStateToProps = (state) => {
  const {
    ui: { selectedGeoObjArray, burgerMenuOpened } = {},
    user: { rights, rolename } = {},
    service: { Api: { userLogout } = {} } = {},
  } = state;
  return {
    selectedGeoObjArray,
    rights,
    rolename,
    userLogout,
    burgerMenuOpened
  };
};

export const HeaderMain = (props) => {
  const { activSuperCat, activSubCat } = props;
  const userName = useSelector((s) => s?.user?.userName);
  const userRoleName = useSelector((s) => s?.user?.rolename);

  const {
    selectedGeoObjArray = [],
    rights = {},
    rolename,
    userLogout,
    burgerMenuOpened
  } = useSelector(mapStateToProps);

  const history = useHistory();

  const checkDirRight = () => {
    for (let k in rights) {
      if (k.substring(0, 3) === "dir") return true;
    }
    return false;
  };

  const detailsOptions = [
    {
      id: 0,
      text: "Детализация",
      disabled: true,
      show: false,
    },
    {
      id: 1,
      link: "/doc2",
      text: "Детализация по трекеру",
      disabled: !(selectedGeoObjArray?.length === 1),
    },
    {
      id: 2,
      link: "/doc",
      text: "Групповая детализация",
      disabled: !(selectedGeoObjArray?.length > 1),
    },
  ];

  const userOptions = [
    {
      id: 0,
      text: userRoleName || userName || "Пользователь",
      disabled: true,
      show: false,
    },
    {
      id: 1,
      link: "/setting",
      text: "Настройки",
      disabled: true,
    },
    {
      id: 2,
      link: "/profile",
      text: "Профиль",
      disabled: true,
    },
    {
      id: 3,
      text: "Выход",
      action: userLogout,
      clearCache: true
    },
  ];

  const onListMenuItemChange = (e, listOptions) => {
    const currentItem = listOptions[e.target.value];

    if (!currentItem || listOptions[e.target.value].disabled) return;

    if (currentItem.action) {
      currentItem.action();
    } else {
      currentItem.link && history.push(currentItem.link);
    }

    if (currentItem.clearCache) {
      // при логауте очистить переданные ключи !!!
      cacheCleaner([storageKeys.DIRECTORY_LIST])
    }
  };

  const leftMenu = [
    { link: "/", name: "Карта", icon: MapIcon },
    // {link: '/doc2', name: 'Детализация', disabled:!(selectedGeoObjArray?.length===1), icon: DetailsIcon, renderComponent: detailsComponent},
    {
      icon: DetailsIcon,
      renderComponent: (
        <StylizedMenuList
          onSelectChange={(e) => onListMenuItemChange(e, detailsOptions)}
          optionList={detailsOptions}
        />
      ),
    },
    {
      link: "/dashboard",
      name: "Дашборды",
      disabled: !(selectedGeoObjArray?.length === 1),
      icon: DashboardsIcon,
    },
  ];

  const rightMenu = [
    {
      link: "/document",
      path: "/document/:id?",
      name: "Документы",
      disabled: false,
      icon: DescriptionIcon,
    },
    {
      link: "/directory",
      path: "/directory/:id?",
      name: "Справочники",
      disabled: !checkDirRight(),
      icon: CopyIcon,
    },
    { link: "/reports", name: "Отчеты", icon: DocumentIcon },
    {
      icon: UserIcon,
      renderComponent: (
        <StylizedMenuList
          onSelectChange={(e) => onListMenuItemChange(e, userOptions)}
          optionList={userOptions}
          className={"userOptions"}
        />
      ),
    },
  ];

  const location = useLocation();
  const { pathname = "" } = location;

  const checkLinkActive = (item) => {
    const { path, link } = item;
    // ссылка должна быть активной и в случае, когда 1 из элементов renderComponent-а входит в состав url !!!
    const matchedRenderedComponent =
      item?.renderComponent?.props?.optionList.find(
        (el) => el.link === pathname
      );
    return (
      matchPath(pathname, { path: path ? path : link, exact: true }) ||
      !!matchedRenderedComponent
    );
  };

  const [columnSpacing, setColumnSpacing] = useState(12.5);

  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;

      if (screenWidth >= 1300) {
        setColumnSpacing(12.5);
      } else if (screenWidth <= 1300) {
        setColumnSpacing(3);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <Box
        sx={{
          flexGrow: 1,
          "@media screen and (max-width: 762px)": {
            display: "none",
          },
        }}
        mt={4}
        mb={2}
      >
        <Grid className={"box-top-menu"}>
          <Grid item xs={2} className={"header-grid"}>
            <Link className="header__logo" href="/">
              <img src={logoSvg} alt="Логотип" />
            </Link>
          </Grid>

          <Grid item xs={10} className={"headerMain"}>
            <Grid
              container
              rowSpacing={2}
              className={"menu-top"}
              columnSpacing={columnSpacing}
            >
              <Grid item xs={6} className={"grid-menu-container"}>
                <Grid
                  container
                  spacing={window.innerWidth >= 1000 ? 3 : 1.5}
                  alignItems={"center"}
                >
                  {leftMenu.map((item, i) => (
                    <Grid item xs={12} sm={4} key={i}>
                      <StylizedMenuItem
                        {...item}
                        base=""
                        active={checkLinkActive(item)}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Grid>

              <Grid item xs={6} className={"grid-menu-container"}>
                <Grid
                  container
                  spacing={window.innerWidth >= 1000 ? 3 : 1.5}
                  alignItems={"center"}
                >
                  {rightMenu.map((item, i) => (
                    <Grid item xs={12} sm={4} key={i}>
                      <StylizedMenuItem
                        {...item}
                        base=""
                        active={checkLinkActive(item)}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>

      <Box
        sx={{
          flexGrow: 1,
          "@media screen and (min-width: 763px)": {
            display: "none",
          },
        }}
        mt={4}
        mb={2}
      >
        <Grid className={"box-top-menu"}>
          <Grid item xs={8} className={"logo-container"}>
            <Link className="header__logo" href="/">
              <img src={logoSvg} alt="Логотип" />
            </Link>
          </Grid>

          <Grid item xs={4} justifyContent="flex-end">
            <Box display="flex" justifyContent="flex-end" className="box-burger">

              <BurgerMenusToggler />

              { burgerMenuOpened?.name === BURGER_MENU_LIST.MAIN_MENU && (
                <div className="popup-menu">
                  {/* Отображение списка leftMenu */}
                  <ul>
                    {leftMenu.map((item, i) => (
                      <li key={i}>
                        <StylizedMenuItem
                          {...item}
                          base=""
                          active={checkLinkActive(item)}
                        />
                      </li>
                    ))}
                  </ul>
                  {/* Отображение списка rightMenu */}
                  <ul>
                    {rightMenu.map((item, i) => (
                      <li key={i}>
                        <StylizedMenuItem
                          {...item}
                          base=""
                          active={checkLinkActive(item)}
                        />
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
